import { ConnectionStatusState } from "./ConnectionStatusState";

export class ConnectionStatus {
  constructor(private connectionStatus: ConnectionStatusState) {}

  public getStatus(): ConnectionStatusState {
    return this.connectionStatus;
  }

  public setStatus(value: ConnectionStatusState): void {
    this.connectionStatus = value;
  }
}
